import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { api, formatApiError } from "@/lib/api";
import logoAlbaker from "@/assets/logo-albaker.png";
import { ArrowUpRight } from "lucide-react";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      toast.error("الرابط غير صالح أو ناقص");
      return;
    }
    if (form.password.length < 8) return toast.error("كلمة المرور يجب أن تكون ٨ أحرف على الأقل");
    if (form.password !== form.confirm) return toast.error("كلمتا المرور غير متطابقتين");

    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: form.password });
      toast.success("تم تعيين كلمة المرور — سجّل الدخول الآن");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err, "الرابط منتهي الصلاحية أو غير صالح"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div dir="rtl" className="min-h-screen bg-ink text-bone flex items-center justify-center container-x py-20">
      <Toaster position="top-left" theme="dark" richColors />
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-3 mb-12">
          <img src={logoAlbaker} alt="Albaker" className="h-10 w-auto" />
          <span className="overline">العودة للموقع</span>
        </Link>

        <div className="overline mb-4">إعادة تعيين كلمة المرور</div>
        <h1 className="font-arabic font-black text-4xl sm:text-5xl text-bone leading-[1.15] mb-10">
          كلمة مرور جديدة.
        </h1>

        <form onSubmit={onSubmit} className="space-y-7" data-testid="reset-form">
          <label className="block">
            <span className="block mb-2 text-xs tracking-[0.2em] uppercase text-white/50">كلمة المرور الجديدة</span>
            <input
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
              className="editorial-input"
              data-testid="reset-password"
              dir="ltr"
            />
          </label>
          <label className="block">
            <span className="block mb-2 text-xs tracking-[0.2em] uppercase text-white/50">تأكيد كلمة المرور</span>
            <input
              type="password"
              required
              value={form.confirm}
              onChange={(e) => setForm((f) => ({ ...f, confirm: e.target.value }))}
              className="editorial-input"
              data-testid="reset-confirm"
              dir="ltr"
            />
          </label>
          <button type="submit" disabled={loading} className="btn-gold group disabled:opacity-60" data-testid="reset-submit">
            <span>{loading ? "جاري الحفظ…" : "تعيين كلمة المرور"}</span>
            <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
